import { gql} from "@apollo/client";
import NETWORK_APOLLO_CLIENTS from "./apolloClient";

export const getProjectMetaService = async (saleAddress, version, chainId) => {
    const projectMetaQuery = `query {
        sales(where: { address: "${saleAddress}" }) {
        id
        address
        deployBlock
        calculatePriceStateConfig {
          sources
          constants
        }
        canStartStateConfig {
          sources
          constants
        }
        canEndStateConfig {
          sources
          constants
        }
        token {
          id
          deployer
          admin
          grantedReceivers
          grantedSenders
          minimumTier
          symbol
          totalSupply
          decimals
          name
          deployBlock
          tier {
            id
          }
        }
        reserve {
          id
          symbol
          totalSupply
          decimals
          name
        }
        recipient
        cooldownDuration
        minimumRaise
        dustSize
        startEvent {
          id
          block
          transactionHash
          timestamp
          sender
        }
        endEvent {
          id
          block
          transactionHash
          timestamp
          sender
          saleStatus
        }
        unitsAvailable
        totalRaised
        percentRaised
        totalFees
        saleStatus
      }
    }`
    return NETWORK_APOLLO_CLIENTS[chainId][version].query({
        query: gql`${projectMetaQuery}`
    });
}

export const salesQuery = async (saleAddress, version, chainId) => {
    const projectMetaQuery = `query {
        sales(where: { address: "${saleAddress}" }) {
      id
      token {
        id
        name
        symbol
        decimals
        totalSupply
        minimumTier
        tier {
          id
          __typename
        }
      }
      calculatePriceStateConfig {
        sources
        constants
      }
      reserve {
        id
        name
        symbol
        decimals
        totalSupply
      }
      cooldownDuration
      deployBlock
      saleStatus
      canStartStateConfig {
        constants
      }
      canEndStateConfig {
        constants
      }
      unitsAvailable
      minimumRaise
    }
    }`
    return NETWORK_APOLLO_CLIENTS[chainId][version].query({
        query: gql`${projectMetaQuery}`
    });
}


